import {
  Show,
  createEffect,
  createMemo,
  createResource,
  createSignal,
  onCleanup,
  onMount,
} from "solid-js";

import { getUserInfoDetails } from "@/api/clientApi/user";
import { Button } from "@/components/Base/Button/Button";
import LazyImg from "@/components/Base/LazyImg";
import Icon from "@/components/Icon";
import { useRouter } from "@/hooks/useRouter";
import { useWatch } from "@/hooks/useWatch";
import { t } from "@/i18n";
import { pubSub } from "@/lib/PubSub";
import { getImgurl } from "@/lib/resFolder";
import { sidebarStore } from "@/stores/sidebar";
import { userStore } from "@/stores/userStore";
import { PubSubEvents } from "@/types/PubSub";
import { GetUserInfoDetailsRsp } from "@/types/swagger/front";

export default function VerifyTip() {
  const [isNeedVerify, setIsNeedVerify] = createSignal(false);
  const { push } = useRouter();

  // 创建响应式的 userInfo 值
  const userInfo = createMemo(() => userStore.userInfo);
  const isLogin = createMemo(() => userStore.isLogin);
  const [info, setInfo] = createSignal<GetUserInfoDetailsRsp | null>(null);

  const menuWidth = createMemo(() => {
    return sidebarStore.state.isExpanded ? "240px" : "72px";
  });

  createEffect(() => {
    if (isLogin()) {
      updateInfo();
    }
  });

  const updateInfo = () => {
    (async () => {
      const res = await getUserInfoDetails();
      setInfo(res as GetUserInfoDetailsRsp);
    })();
  };
  const updateStatus = (val: boolean) => {
    if (val) {
      setIsNeedVerify(false);
    } else {
      const shouldVerify =
        !!userStore.userInfo?.is_pay &&
        !userStore.userInfo?.phone &&
        !userStore.userInfo?.email;
      setIsNeedVerify(shouldVerify);
    }
  };

  onMount(() => {
    pubSub.subscribe(PubSubEvents.UserInfoUpdated, updateStatus);
    const shouldVerify =
      !!userStore.isLogin &&
      !!userStore.userInfo?.is_pay &&
      !userStore.userInfo?.phone &&
      !userStore.userInfo?.email &&
      !info()?.verify?.personal_info?.contact_email &&
      !info()?.verify?.personal_info?.contact_phone;
    setIsNeedVerify(shouldVerify);
    onCleanup(() => {
      pubSub.unsubscribe(PubSubEvents.UserInfoUpdated, updateStatus);
    });
  });

  createEffect(() => {
    const shouldVerify =
      !!isLogin() &&
      !!userInfo()?.is_pay &&
      !userInfo()?.phone &&
      !userInfo()?.email &&
      !info()?.verify?.personal_info?.contact_email &&
      !info()?.verify?.personal_info?.contact_phone;
    setIsNeedVerify(shouldVerify);
  });
  // 监听 userInfo 变化

  const handleVerify = () => {
    push("/settings?tab=security");
  };

  return (
    <Show when={isNeedVerify()} fallback={<></>}>
      <div
        class="bg-general-bg2 fixed bottom-[50px] z-[400] flex h-[93px] w-[533px] items-center gap-x-[12px] rounded-[10px] px-[12px]"
        style={{
          left: `calc(${menuWidth()} + (100vw - ${menuWidth()} - 533px) / 2)`,
        }}
      >
        <LazyImg
          src={getImgurl("setting.png", "common/home")}
          class="h-[56px] w-[56px]"
        />
        <Icon
          name="general/xx2"
          class="absoluteh-[12px] w-[12px]"
          wrapperClass="absolute right-[8px] top-[8px] h-[12px] w-[12px]"
          onClick={() => setIsNeedVerify(false)}
        />
        <div class="text-general-light flex-1 break-normal text-[16px] font-[500]">
          {t("home.verify_notice")}
        </div>
        <div>
          <Button
            variant="primary"
            type="button"
            class="text-general-butzi h-[34px] w-[96px] text-[14px] font-bold"
            onClick={() => handleVerify()}
          >
            {t("settings.verify")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
